import React from 'react';
import ReactDOM from 'react-dom/client'; // Import from 'react-dom/client' in React 18
import './index.css';
import App from './App';
import { LanguageProvider } from './components/LanguageContext';
// import './i18n';
import "@fontsource/nunito"; // Defaults to weight 400
import "@fontsource/nunito/400.css"; // Specify weight
import "@fontsource/nunito/400-italic.css"; // Specify weight and style

import "@fontsource/josefin-sans"; // Defaults to weight 400
import "@fontsource/josefin-sans/400.css"; // Specify weight
import "@fontsource/josefin-sans/400-italic.css"; // Specify weight and style

// Create a root and render your app
const root = ReactDOM.createRoot(document.getElementById('root')); // Use createRoot
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </React.StrictMode>
);
